;(function ($, window, document, undefined) {
  // window.snazzyInfoWindow = null;

  // window.infoBubble = new InfoBubble({
  //     shadowStyle: 0,
  //     padding: 0,
  //     borderRadius: 0,
  //     borderWidth: 0,
  //     hideCloseButton: true,
  //     disableAnimation: true,
  //     backgroundClassName: 'infobubble',
  //     arrowPosition: 50,
  //     arrowSize: 0,
  //     minWidth: 0,
  //     minHeight: 0
  // });

  window.clustermap = function (element) {
    var markers = [];
    var map = null;

    $('[data-marker-listing]').each(function () {
      var $this = $(this);
      var marker = {
        latLng: [$this.data('lat'), $this.data('lng')],
        options: {
          flat: true,
          anchor: RichMarkerPosition.TOP,
          content: '<span class="maps-marker"></span>'
        },
        data: {
          content: $this.attr('data-content'),
          url: $this.attr('data-url')
        }
      };
      markers.push(marker);
    });

    element.gmap3({
        defaults: {
          classes: {
            Marker: RichMarker
          }
        },
        map: {
          options: {
            center: [52.132633, 5.291266],
            zoom: 6,
            maxZoom: 1000,
            scrollwheel: true,
            mapTypeId: "wvdw",
            mapTypeControlOptions: {
              mapTypeIds: []
            }
          },
        },
        marker: {
          values: markers,
          // cluster: {
          //   radius: 100,
          //   maxZoom: 14,
          //   0: {
          //     content: "<div class='cluster'>CLUSTER_COUNT</div>",
          //     width: 53,
          //     height: 52
          //   },
          //   events: {
          //     click: function (cluster, event, data) {
          //       cluster.main.map.panTo(data.data.latLng);
          //       cluster.main.map.setZoom(cluster.main.map.getZoom() + 2);
          //     }
          //   }
          // },
          options: {
            draggable: false
          },
          events: {
            click: function (marker, event, context) {
              var map = $(this).gmap3('get');

              window.snazzyInfoWindow = new SnazzyInfoWindow({
                wrapperClass: 'snazzyinfowindow',
                marker: marker,
                content: context.data.content,
                border: false,
                placement: top,
                showCloseButton: false,
                backgroundColor: 'rgba(255, 255, 255, 1)',
                shadow: false,
                offset: {
                  top: '-5px'
                },
                closeOnMapClick: true,
                padding: 0
              });

              $(".si-float-wrapper").remove();
              window.snazzyInfoWindow.open();
            },
            mouseout: function () {
              // window.snazzyInfoWindow.close();
            },
            click: function (marker, event, context) {
              window.snazzyInfoWindow = new SnazzyInfoWindow({
                wrapperClass: 'snazzyinfowindow',
                marker: marker,
                content: context.data.content,
                border: false,
                placement: top,
                showCloseButton: false,
                backgroundColor: 'rgba(255, 255, 255, 1)',
                shadow: false,
                offset: {
                  top: '-5px'
                },
                closeOnMapClick: true,
                padding: '30px 0'
              });

              $(".si-float-wrapper").remove();
              window.snazzyInfoWindow.open();
            }
          },
        },
        styledmaptype: {
          id: "wvdw",
          options: {
            name: "Wvdw map"
          },
          styles: [
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "administrative.province",
              elementType: "labels",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#8ccaae"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [
                {
                  lightness: 100
                },
                {
                  visibility: "simplified"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#c3b9ae"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "labels",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "labels",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "transit",
              elementType: "geometry.fill",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#005469"
                },
                {
                  visibility: "on"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#e9e9e9"
                },
                {
                  visibility: "on"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [
                {
                  invert_lightness: true
                },
                {
                  lightness: "-100"
                }
              ]
            }
          ]
        },
        autofit: {}
      }
    );
  };

})(jQuery, window, document);



// WEBPACK FOOTER //
// ./assets/js/google/clustermap.js